function FlatButton({
  children,
  type,
  name,
  id,
  className,
  onClick,
  appearance = "primary",
  disabled,
  size = "md",
}) {
  const appearanceClass = {
    primary:
      "bg-gray-800 rounded-md shadow-sm disabled:bg-gray-500 disabled:opacity-75  text-white font-semibold  hover:bg-gray-600 focus-visible:outline-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
    secondary:
      "bg-white rounded-md shadow-sm disabled:bg-gray-200 disabled:opacity-50  text-gray-900 font-semibold ring-gray-300 hover:bg-gray-50 ring-1 ring-inset ",
  };
  const sizeClass = {
    xs: "px-2 py-1 text-xs",
    sm: "px-2 py-1 text-sm",
    md: "px-2.5 py-1.5 text-sm",
    lg: "px-3 py-2 text-sm",
    xl: "px-3.5 py-2.5 text-sm",
  };
  return (
    <button
      onClick={(e) => {
        onClick && onClick(e);
      }}
      type={type || "button"}
      class={`
      ${className || ""} 
      ${appearanceClass[appearance || "primary"]} 
      ${sizeClass[size || "md"]} 
      `}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export default FlatButton;
